module.exports = __webpack_public_path__ + "static/media/auric-forest.6d1f7206.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/assets/images/group logos/auric-forest.svg
// module id = 65
// module chunks = 0